var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_12932",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_12932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1331 28.6167C12.7553 29.3167 14.4886 29.6667 16.3331 29.6667C18.1775 29.6667 19.9109 29.3167 21.5331 28.6167C23.1553 27.9167 24.5664 26.9667 25.7664 25.7667C26.9664 24.5667 27.9164 23.1556 28.6164 21.5333C29.3164 19.9111 29.6664 18.1778 29.6664 16.3333C29.6664 14.4889 29.3164 12.7556 28.6164 11.1333C27.9164 9.51111 26.9664 8.1 25.7664 6.9C24.5664 5.7 23.1553 4.75 21.5331 4.05C19.9109 3.35 18.1775 3 16.3331 3C14.4886 3 12.7553 3.35 11.1331 4.05C9.51087 4.75 8.09976 5.7 6.89976 6.9C5.69976 8.1 4.74976 9.51111 4.04976 11.1333C3.34976 12.7556 2.99976 14.4889 2.99976 16.3333C2.99976 18.1778 3.34976 19.9111 4.04976 21.5333C4.74976 23.1556 5.69976 24.5667 6.89976 25.7667C8.09976 26.9667 9.51087 27.9167 11.1331 28.6167Z",
    fill: "#B46C9F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 15,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.3a06570c41e907ed549b4cc48eca4252.svg";
export { ForwardRef as ReactComponent };